/**
 * Apple Store Map Appointment Tracking HECHO POR IVAN PEREZ VENERO | ISHOP
 * 
 * This script tracks clicks on "Agendar cita" links in store location services content.
 * Add this script to your theme.liquid or to your store locator page.
 */

(function() {
  // Setup tracking immediately and also when DOM content loads
  setupStoreMapTracking();
  document.addEventListener('DOMContentLoaded', setupStoreMapTracking);
  
  // Also run tracking setup after page interactions that might load new content
  document.addEventListener('click', function(e) {
    // When accordion buttons are clicked (may reveal appointment links)
    if (e.target.closest('.js-acc-button') || e.target.classList.contains('js-acc-button')) {
      setTimeout(setupStoreMapTracking, 100);
    }
    
    // When "Seleccionar como mi tienda" button is clicked (may update store details)
    if (e.target.closest('.js-make-my-store-btn') || e.target.classList.contains('js-make-my-store-btn')) {
      setTimeout(setupStoreMapTracking, 500);
    }
  });
  
  // Create a MutationObserver to detect when new service content is added
  const observer = new MutationObserver(function(mutations) {
    let shouldSetupTracking = false;
    
    mutations.forEach(function(mutation) {
      // If nodes were added and they contain accordion content
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === 1 && (
              node.classList?.contains('my-location-result__services') || 
              node.querySelector?.('.my-location-result__services') ||
              node.querySelector?.('a[href*="getsupport.apple.com/repair-locations"]')
            )) {
            shouldSetupTracking = true;
            break;
          }
        }
      }
    });
    
    if (shouldSetupTracking) {
      setupStoreMapTracking();
    }
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /**
   * Main function to set up tracking on appointment links
   */
  function setupStoreMapTracking() {
    // Find all appointment links in service sections that don't already have tracking
    const appointmentLinks = document.querySelectorAll(
      '.my-location-result__services a[href*="getsupport.apple.com/repair-locations"]:not([data-tracking-added])'
    );
    
    if (appointmentLinks.length === 0) return;
    
    appointmentLinks.forEach(link => {
      // Mark this link as having tracking added
      link.setAttribute('data-tracking-added', 'true');
      
      // Add click event listener
      link.addEventListener('click', function(e) {
        // Find the parent location container
        const locationCard = this.closest('.js-my-location-result');
        
        if (!locationCard) return;
        
        // Extract location name from the data attribute or from the card
        let locationName = locationCard.getAttribute('data-name');
        
        if (!locationName) {
          const nameElement = locationCard.querySelector('.my-location-result__name');
          locationName = nameElement ? nameElement.textContent.trim() : 'Unknown Location';
        }
        
        // Get location ID if available
        const locationId = locationCard.getAttribute('data-id') || null;
        
        // Send event to Google Tag Manager (using the same event name as service-centers.js)
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'service_appointment_click',  // Using the same event name as service-centers.js
            'location_name': locationName,
            'location_id': locationId
          });
          
          console.log('GTM event pushed for store appointment:', locationName);
        } else {
          console.error('Google Tag Manager dataLayer not found');
          // Fallback to sending directly to GA4 if available
          if (typeof gtag === 'function') {
            gtag('event', 'service_appointment_click', {
              'location_name': locationName,
              'location_id': locationId
            });
            console.log('Sent directly to GA4 for store appointment:', locationName);
          }
        }
      });
    });
  }
})();